import { Image, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { ICardProps } from './types';

import * as S from './styled';

const Card = ({ img, title, description }: ICardProps) => {
    const { t } = useTranslation();

    return (
        <S.Card>
            <Image src={img} alt="slide" maxWidth={296} mb={16} />
            <Text medium mb={4} type="h6">
                {t(title)}
            </Text>
            <Text mb={12} type="small-text" color="text-secondary-subdued">
                {t(description)}
            </Text>
        </S.Card>
    );
};

export default Card;
